import React from 'react';
import {Title, TitleLevel, TitleSize} from 'components/ui/Title';
import Container from 'components/layout/Container';
import FirstScreenSwiper from 'components/ui/FirstScreenSwiper';
import ArrowRight from 'components/ui/icon/ArrowRight';
import {useAnalytics} from 'contexts/Analytics';

import './FirstScreen.scss';

const FirstScreen = ({innerRef}) => {
  const {handleEvent} = useAnalytics();

  return (
    <section ref={innerRef} className="first-screen">
      <Container extraClassName="first-screen__wrapper">
        <div className="first-screen_left">
          <Title
            extraClassName="first-screen__title"
            level={TitleLevel.H2}
            size={TitleSize.H2}
          >
            Мы&nbsp;придумали ремонт&nbsp;ванных по&#8209;новому&nbsp;
            <sup className="first-screen__title-superscript">beta</sup>
          </Title>

          <p className="first-screen__title-subscript">
            Просто и&nbsp;доступно&nbsp;&mdash; экономим и&nbsp;деньги
            и&nbsp;нервы
          </p>

          <a
            className="first-screen__button"
            href="#form"
            onClickCapture={handleEvent('continue_button_click')}
          >
            Отправить заявку <ArrowRight />
          </a>
        </div>

        <FirstScreenSwiper />
      </Container>
    </section>
  );
};

export default FirstScreen;
